module.exports = __webpack_public_path__ + "static/img/ylfwIcon.e309d356.png";